module.exports = __webpack_public_path__ + "static/media/img8.e2fa2f9d.jpg";